module.exports = new __parcel__URL__("Sales Account Planning Hover.f968f550.svg").toString();